export const UPDATE_USER_CONTEXT = 'UPDATE_USER_CONTEXT';
export const UPDATE_ROLE_CONTEXT = 'UPDATE_ROLE_CONTEXT';
